import styled from "styled-components";

export const StyledIconBg = styled('div')<{
    isResponsive?: boolean;
}>(({ theme }) => ({
    background: 'white',
    border: 'none',
    borderRadius: '50%',
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'all 0.2s',
    backgroundColor: theme.CorporateTheme.colors.background,
}));
